import { cn } from "@/lib/utils";

export default function LogoIcon({ className }: { className?: string }) {
	return (
		<svg
			className={cn("size-8", className)}
			viewBox="0 0 1200 1200"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Clerical Logo</title>
			<circle
				cx="600"
				cy="600"
				r="548"
				fill="none"
				stroke="currentColor"
				strokeWidth="56"
			/>
			<path
				fill="currentColor"
				d="M915.6 950.4c-26.398 27.602-62.398 40.801-97.199 40.801-34.801 0-70.801-14.398-97.199-40.801l-420-420c-73.199-73.199-73.199-192 0-265.2 34.801-36 82.801-55.199 132-55.199s96 19.199 132 55.199l357.6 357.6c7.1992 7.1992 7.1992 18 0 25.199-7.1992 7.1992-18 7.1992-25.199 0l-358.8-357.6c-28.801-28.801-67.199-44.398-106.8-44.398s-78 15.602-106.8 44.398c-58.801 60-58.801 156 0 214.8l420 420c39.602 39.602 104.4 39.602 144 0 39.602-39.602 39.602-104.4 0-144l-420-420c-21.602-21.602-57.602-21.602-79.199 0-10.801 10.801-16.801 24-16.801 39.602 0 14.398 6 28.801 16.801 39.602l184.8 187.2c7.1992 7.1992 7.1992 18 0 25.199s-18 7.1992-25.199 0l-186-186c-36-36-36-94.801 0-130.8s94.801-36 130.8 0l420 418.8c53.996 54 53.996 141.6 1.1992 195.6z"
			/>
		</svg>
	);
}
